/* ── FormLabel: bordered container with floating label ── */

.labelContainer {
    align-items: baseline;
    border: 1px solid #e0e4ed;
    border-radius: 0.25rem;
    display: flex;
    margin: 2rem 0;
    padding: 0.25rem;
    position: relative;
}

.labelContainer:focus-within {
    border: 1px solid hsla(20, 100%, 59%, 1);
}

.labelContainer:hover .labelText,
.labelContainer:focus-within .labelText {
    font-weight: bold;
}

.labelText {
    background-color: white;
    color: #222;
    font-size: 0.875rem;
    font-weight: normal;
    left: 1rem;
    line-height: 0.875rem;
    max-width: 16rem;
    overflow: hidden;
    padding: 0 0.25rem;
    position: absolute;
    text-overflow: ellipsis;
    top: calc(0.875rem / -2);
    white-space: nowrap;
    z-index: 1;
}

.labelText.active {
    font-weight: bold;
}

/* Global inner classes from dokumentgenerator library */

.labelContainer :global(.xvar-form-input-wrapper) {
    flex: 1;
    display: flex;
    align-items: baseline;
}

.labelContainer :global(.xvar-form-comment) {
    margin-right: 1rem;
    font-size: 0.875rem;
    color: #9EA0A5;
}

/* ── RadioGroup + Radio ── */

.radioGroup {
    display: flex;
    flex-direction: column;
    list-style: none;
    margin: 0;
    padding: 1.5rem 1rem;
    width: 100%;
}

.radio {
    margin-bottom: 1rem;
}

.radio:last-of-type {
    margin-bottom: 0;
}

.radioLabel {
    cursor: pointer;
    display: flex;
    align-items: center;
}

.radioSvg {
    flex-shrink: 0;
    height: 1.5rem;
    margin-right: 1rem;
    width: 1.5rem;
}

.radioCircleBorder {
    fill: transparent;
    stroke: #e0e4ed;
}

.radioCircleBorder.checked {
    stroke: hsl(197, 97%, 12%);
}

.radioCircleFill {
    fill: transparent;
}

.radioCircleFill.checked {
    fill: hsl(197, 97%, 12%);
}

.radioName {
    color: #222;
    font-size: 1rem;
    line-height: 1.5rem;
}

/* ── Checkbox ── */

.checkbox {
    cursor: pointer;
}

.visualCheckbox {
    border: 2px solid hsl(197, 87%, 18%);
    border-radius: 0.25rem;
    display: block;
    height: 1.5rem;
    width: 1.5rem;
}

.visualCheckbox.checked {
    background-color: hsl(197, 87%, 18%);
}

.checkboxSvg {
    height: 100%;
    width: 100%;
}

.checkmark {
    fill: none;
    stroke: #fff;
    stroke-dasharray: 32.5, 32.5;
    stroke-dashoffset: 32.5;
    stroke-width: 4;
    transition: stroke-dashoffset 0.25s ease;
}

.checkmark.checked {
    stroke-dashoffset: 0;
}

/* ── OptionalForm overrides ── */

.optionalLabel {
    align-items: start;
    padding: 1.5rem 1rem;
}

.optionalCheckbox {
    margin-right: 1rem;
}

.optionalText {
    margin: 0;
}

/* ── XListForm ── */

.xListFieldset {
    background-color: hsl(195, 20%, 96%);
    border: none;
    border-radius: 0.25rem;
    margin: 2rem 0;
    padding: 0;
}

.xListHeader {
    align-items: flex-start;
    border-radius: 0.25rem 0.25rem 0 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 0 0 1rem 0;
    padding: 1.5rem 1rem;
}

.xListHeaderInput {
    background-color: transparent;
    border: 1px solid #e0e4ed;
    border-radius: 0.25rem;
    box-sizing: content-box;
    font-size: 1rem;
    margin-left: 0.5rem;
    padding: 0.25rem 0.5rem 0.25rem 1rem;
    text-align: center;
    width: 3rem;
}

.xListChildren {
    margin: 0 1rem;
}

.xListChildren .labelContainer {
    background-color: hsl(195, 20%, 96%);
}

.xListChildren .labelText {
    background-color: hsl(195, 20%, 96%);
}

.xListChildren :global(input) {
    background-color: hsl(195, 20%, 96%);
}

/* ── DropdownMenu ── */

.dropdownMenu {
    background-color: white;
    border-radius: 0.25rem;
    list-style: none;
    margin: 0;
    max-height: 24rem;
    outline: 0;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 0;
    position: absolute;
    max-width: initial;
    z-index: 100;
}

.dropdownMenu.isOpen {
    border: 1px solid #e0e4ed;
    box-shadow: 0 5px 15px hsla(0, 0%, 0%, 0.2);
    margin-top: -1.5rem;
    max-width: calc(24rem - 3rem);
    min-width: 345px;
    padding: 0.5rem 0;
}

/* ── DropdownMenuItem ── */

.dropdownMenuItem {
    cursor: pointer;
    margin: 0.5rem -0.5rem;
    padding: 0.5rem 1rem 0.5rem 1.5rem;
}

.dropdownMenuItem:hover,
.dropdownMenuItem:active,
.dropdownMenuItem.isActive {
    background-color: hsl(195, 20%, 96%);
    border-radius: 0.5rem;
}

.dropdownMenuItem.isSelected {
    font-weight: bold;
}

.dropdownMenuItem p {
    color: #222;
    margin: 0;
}

.dropdownMenuItem span {
    color: rgba(0, 0, 0, 0.6);
    font-size: 0.75rem;
    font-weight: normal;
    margin-top: 0.25rem;
}

/* ── DocumentGeneratorInput ── */

.docgenInput {
    border: none;
    flex: 1;
    font-size: 1rem;
    outline: none;
    padding: 0.75rem 1rem;
}

.docgenInput::placeholder {
    color: #9EA0A5;
}

/* ── UndoButton ── */

.undoButton {
    background: transparent;
    border: none;
    border-radius: 0.25rem;
    cursor: pointer;
    margin: 0 0.25rem;
    padding: 0.5rem;
}

.undoButton:hover,
.undoButton:focus {
    background-color: rgba(0, 0, 0, 0.1);
}

.undoButton:active {
    background-color: rgba(0, 0, 0, 0.3);
}

.undoButton svg {
    height: 1rem;
    width: 1rem;
}
